import { module } from 'modujs';
import * as CookieConsent from 'vanilla-cookieconsent';
import {CUSTOM_EVENT} from "../config.js";

export default class extends module {
    constructor(m)
    {
        super(m)

        try {
            this.config = JSON.parse(this.getData('config'));
        } catch (err) {
            console.warn(err.message);
        }

        this.events = {
            click: {
                hide: 'hideModal',
                'show-preferences': 'showPreferences'
            },
        };
    }

    init()
    {
        if (!this.config.categories || Object.keys(this.config.categories).length === 0) {
            console.warn('[CookieConsent]', 'No categories configured.');
            return;
        }

        this.config.categories = this.prepareCategories(this.config.categories);

        window.addEventListener(CUSTOM_EVENT.READY, this.onReady = () => {
            CookieConsent.run(Object.assign({
                // onConsent: () => {
                //     this.toggleCategoryAnalytics();
                // },
                // onChange: ({ changedCategories }) => {
                //     if (changedCategories.includes('analytics')) {
                //         this.toggleCategoryAnalytics();
                //     }
                // },
            }, this.config));
        })


        document.addEventListener("click", event => {
            let target = event.target;
            while (target && target !== document) {
                if (target.matches('a')) {
                    if (target.getAttribute('href') === '#show-cookie-preferences') {
                        event.preventDefault();
                        event.stopPropagation();
                        CookieConsent.showPreferences();
                    } else if (target.getAttribute('data-cookie-consent') === 'hide') {
                        CookieConsent.hidePreferences();
                        CookieConsent.hide();
                    }

                    break;
                }
                target = target.parentNode;
            }
        }, false);
    }

    prepareCategories(categories)
    {
        for (const [ categoryName, categoryData ] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    showPreferences()
    {
        CookieConsent.showPreferences();
    }

    hideModal()
    {
        CookieConsent.hidePreferences();
        CookieConsent.hide();
    }
}
